// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1EO7H","overflowing":"ReadFullNote_overflowing__1fynG"};